import styles from './Changelog.module.css';

import config from 'config.js';
import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { PageHeader, Card, Spin, Tag, Button, Popconfirm, Radio, DatePicker, Input, Collapse, Upload, Col, Modal, Form, Menu, Dropdown, Select, List, message, Avatar, Typography } from 'antd';

import {
  ReloadOutlined,
  DeleteOutlined,
  LinkOutlined,
  SendOutlined
} from '@ant-design/icons';

import {
  getChangelog, createChange, removeChange, publishChange
} from 'store/ducks/changelog.js';

const Changelog = () => {
  const dispatch = useDispatch();

  const [showAddChange, setShowAddChange] = useState(false);

  const [createName, setCreateName] = useState('');
  const [createDescription, setCreateDescription] = useState('');
  const [createLink, setCreateLink] = useState('');
  const [createBadge, setCreateBadge] = useState(null);

  const getChangelogLoading = useSelector(state => state.changelog.getChangelog.loading);
  const createLoading = useSelector(state => state.changelog.createChange.loading);

  const changelog = useSelector(state => state.changelog.changelog);

  const reload = () => {
    dispatch(getChangelog());
  };

  const clear = () => {
    setCreateName('');
    setCreateDescription('');
    setCreateLink('');
    setCreateBadge(null);
  };

  useEffect(() => {
    clear();
    reload();
  }, []);

  const addChangeSubmitModal = () => {
    dispatch(createChange({
      name: createName,
      description: createDescription,
      link: createLink,
      badge: createBadge,
    })).then(() => {
      closeAddChangeModal();
      clear();
      reload();
    });
  };

  const deleteChange = (id) => dispatch(removeChange(id)).then(() => reload());
  const openAddChangeModal = () => setShowAddChange(true);
  const closeAddChangeModal = () => setShowAddChange(false);

  const publish = (ids) => {
    let promises = [];

    for (let id of ids) {
      promises.push(dispatch(publishChange(id)));
    }

    Promise.all(promises).then(() => reload());
  };

  return (
    <>
      <PageHeader
        title="Changelog"
        style={{ border: '1px solid #f0f0f0', background: '#fff', margin: '0 0 15px 0' }}
        extra={[
          <Button type="primary" ghost key="mails" target="_blank" onClick={() => openAddChangeModal()}>Add</Button>,
          <Popconfirm title="Are you sure?" onConfirm={() => publish(changelog.filter((f) => !f.published).map((f) => f._id))}okText="Yes" cancelText="No">
            <Button type="primary" key="publish" target="_blank">Publish All</Button>
          </Popconfirm>,
          <Button onClick={() => reload()}><ReloadOutlined /></Button>
        ]}
      />

      <Spin spinning={getChangelogLoading} size="large">
        <Card style={{ width: '100%', minHeight: 224, padding: '40px 0 0 0' }}>
          <List bordered
            dataSource={changelog || []}
            renderItem={(item) => <List.Item key={item._id} style={{ background: item.published ? '#DEFDE0' : '#FCF7DE' }}>
              <List.Item.Meta
                title={<>{item.name} {item.link && <Typography.Link href={item.link} target="_blank"><LinkOutlined /></Typography.Link>}</>}
                description={<>
                  {item.description && <>
                    <Typography.Text type="secondary">{item.description}</Typography.Text><br />
                  </>}
                  <Typography.Text type="secondary">{moment(item.createdAt).format('DD/MM/YYYY')}</Typography.Text>
                  {item.badge && <Tag style={{ margin: '0 0 0 15px' }}>{item.badge}</Tag>}
                </>}
              />
              <div>
                <Button type="dashed" danger shape="circle" icon={<DeleteOutlined />} onClick={() => deleteChange(item._id)} />
                <Button type="dashed" shape="circle" icon={<SendOutlined />} onClick={() => publish([item._id])} style={{ margin: '0 0 0 5px' }} />
              </div>
            </List.Item>} />
        </Card>
      </Spin>

      <Modal title="Add Change" visible={showAddChange} onOk={() => addChangeSubmitModal()} onCancel={() => closeAddChangeModal()}>
        <Spin spinning={createLoading} size="large">
          <Input value={createName} autoFocus={true} style={{ width: '100%', margin: '0 0 15px 0' }} onChange={(e) => setCreateName(e.target.value)} placeholder="Label" />

          <Input.TextArea value={createDescription} rows={4} style={{ width: '100%', margin: '0 0 15px 0' }} onChange={(e) => setCreateDescription(e.target.value)} placeholder="Description" />
          <Input value={createLink} style={{ width: '100%', margin: '0 0 15px 0' }} onChange={(e) => setCreateLink(e.target.value)} placeholder="Link" />

          <Radio.Group value={createBadge} onChange={(e) => setCreateBadge(e.target.value)}>
            <Radio.Button value="newFeature">New Feature</Radio.Button>
            <Radio.Button value="upgrade">Upgrade</Radio.Button>
            <Radio.Button value="change">Change</Radio.Button>
          </Radio.Group>
        </Spin>
      </Modal>
    </>
  );
}

export default Changelog;
